import { ToastManagerRepository } from "@core/domain/repositories/toast-manager.repository";
import { LoadLayoutStore } from "@core/presentation/components/feedback/load-layout/load-layout.store";
import { AuthenticationResetPasswordUseCase } from "@iot-platform/authentication";
import { BaseViewModel } from "@iot-platform/core";
import { t } from "i18next";
import { inject, injectable } from "inversify";
import { action, makeObservable, observable, runInAction } from "mobx";
import type { ResetPasswordFormValuesValidated } from "./reset-password.form";

@injectable()
export class ResetPasswordViewModel extends BaseViewModel {
    @observable
    initialLoading = true;

    constructor(
        @inject(AuthenticationResetPasswordUseCase)
        private readonly authenticationResetPasswordUseCase: AuthenticationResetPasswordUseCase,
    ) {
        super();
        makeObservable(this);
    }

    override didMount(): void {
        this.initViewData();
    }

    @action
    initViewData(): void {
        runInAction(() => {
            this.initialLoading = false;
        });
    }

    async submitPasswordReset(
        values: ResetPasswordFormValuesValidated,
    ): Promise<boolean> {
        LoadLayoutStore.start();

        const passwordResetResult =
            await this.authenticationResetPasswordUseCase.execute(
                values.token,
                values.newPassword,
                values.confirmPassword,
            );

        LoadLayoutStore.finish();

        if (passwordResetResult) {
            ToastManagerRepository.success(
                t("public:authentication.resetPassword.success"),
            );
        }

        return passwordResetResult;
    }
}
